'use client';
import React from 'react';
import { InfoBarInner } from './InfoBarInner';
import styled, { TC } from '@benzinga/themetron';
import { InfoBarModule } from './Modules';
import { Checkbox, Dropdown } from 'antd';
import { Settings } from '@benzinga/valentyn-icons';
const InfoBarSettings: React.FC<{
  modules: InfoBarModule[];
  activeModuleList: string[];
  setActiveModules: (activeModules: string[]) => void;
}> = props => {
  return (
    <InfoBarSettingsDiv>
      <table>
        {props.modules.map(module => {
          return (
            <tr key={module.id}>
              <td
                style={{
                  paddingRight: '10px',
                }}
              >
                <Checkbox
                  checked={props.activeModuleList.includes(module.id)}
                  onChange={e => {
                    if (e.target.checked) {
                      props.setActiveModules([...props.activeModuleList, module.id]);
                    } else {
                      props.setActiveModules(props.activeModuleList.filter(m => m !== module.id));
                    }
                  }}
                  style={{
                    verticalAlign: 'middle',
                  }}
                />
              </td>
              <td>{module.name}</td>
            </tr>
          );
        })}
      </table>
    </InfoBarSettingsDiv>
  );
};

const InfoBarSettingsIcon: React.FC<{
  modules: InfoBarModule[];
  activeModuleList: string[];
  setActiveModules: (activeModules: string[]) => void;
}> = props => {
  return (
    <Dropdown
      arrow
      menu={{
        items: [
          {
            key: 'settings',
            label: <InfoBarSettings {...props} />,
          },
        ],
      }}
      trigger={['click']}
    >
      <Settings />
    </Dropdown>
  );
};

export const InfoBar: React.FC<{ className?: string; modules: InfoBarModule[] }> = props => {
  const [hovered, setHovered] = React.useState(false);
  const fadeInConfig = React.useMemo(
    () => ({
      delay: 0.05,
      duration: 2,
      gradientWidthPercentage: 10,
    }),
    [],
  );
  const fadeOutConfig = React.useMemo(
    () => ({
      delay: 4,
      duration: 2,
      gradientWidthPercentage: 10,
    }),
    [],
  );

  const [activeModulesList, setActiveModulesList] = React.useState(() => {
    return props.modules.map(module => module.id);
  });

  React.useEffect(() => {
    setActiveModulesList(props.modules.map(module => module.id));
  }, [props.modules]);

  const activeModules = React.useMemo(() => {
    return props.modules.filter(m => activeModulesList.includes(m.id));
  }, [props.modules, activeModulesList]);

  return (
    <Container className={props.className}>
      <InfoBarSettingsIconContainer>
        <InfoBarSettingsIcon
          activeModuleList={activeModulesList}
          modules={props.modules}
          setActiveModules={setActiveModulesList}
        />
      </InfoBarSettingsIconContainer>
      <InfoBarContainer onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        <InfoBarInner
          fadeInConfig={fadeInConfig}
          fadeOutConfig={fadeOutConfig}
          modules={activeModules}
          pauseAnimation={hovered}
        />
      </InfoBarContainer>
    </Container>
  );
};

const Container = styled(TC.Row)`
  position: relative;
  display: flex;
  gap: 4px;
  overflow: hidden;
  background: ${props => props.theme.colors.border};
`;

const InfoBarContainer = styled.div`
  background: ${props => props.theme.colors.background};
  font-size: 12px;
  padding: 0;
  position: relative;
  flex-grow: 1;
`;

const InfoBarSettingsIconContainer = styled.div`
  background: ${props => props.theme.colors.background};
  font-size: 19px;
  width: 60px;
  text-align: center;
`;

const InfoBarSettingsDiv = styled.div`
  background: ${props => props.theme.colors.backgroundActive};
  border: 1px solid ${props => props.theme.colors.border};
  font-size: 14px;
  width: fit-content;
  height: fit-content;
  padding: 5px;
`;
